export default "__VITE_ASSET__DqafhDzR__"